function columnIdsByName(table) {
  let columnNames = table.columnNames
  let columnsCount = columnNames.length
  let ids = new Map()
  for(let columnId = 0; columnId < columnsCount; columnId++) {
    const columnName = columnNames[columnId]
    ids.set(columnName, columnId)
  }
  return ids
}

function eachRow(table, columnNames, cb) {
  const idsByName = columnIdsByName(table)
  const ids = columnNames.map(column => {
    if(column instanceof Array) {
      for(let cn of column) if(idsByName.has(cn)) return idsByName.get(cn)
    } else {
      return idsByName.get(column)
    }
  })
  for(let row of table.rows) {
    let vals = ids.map(id => row[id])
    cb(...vals)
  }
}

function anyRow(table, columnNames, cb) {
  let found = false
  eachRow(table, columnNames, (...args) => found = found || cb(...args))
  return found
}

function allRows(table, columnNames, cb) {
  let found = true
  eachRow(table, columnNames, (...args) => found = found && cb(...args))
  return found
}

function sum(table, column) {
  let sum = 0
  let columnId
  if(column instanceof Array) {
    for(let i = 0; i < table.columnNames.length; i++) if(column.indexOf(table.columnNames[i]) != -1) columnId = i
  } else {
    for(let i = 0; i < table.columnNames.length; i++) if(table.columnNames[i] == column) columnId = i
  }
  for(let row of table.rows) {
    sum += +row[columnId]
  }
  return sum
}

function average(table, column) {
  return sum(table, column) / table.rows.length
}

function hasColumn(table, column) {
  if(column instanceof Array) {
    for(let i = 0; i < table.columnNames.length; i++) if(column.indexOf(table.columnNames[i]) != -1) return true
  } else {
    for(let i = 0; i < table.columnNames.length; i++) if(table.columnNames[i] == column) return true
  }
  return false
}


function getColumnName(table, column) {
  if(column instanceof Array) {
    for(let i = 0; i < table.columnNames.length; i++) if(column.indexOf(table.columnNames[i]) != -1)
      return table.columnNames[i]
  } else {
    for(let i = 0; i < table.columnNames.length; i++) if(table.columnNames[i] == column) return column
  }
  return false
}

export default {
  columnIdsByName,
  anyRow,
  allRows,
  sum,
  average,
  hasColumn,
  getColumnName
}



// WEBPACK FOOTER //
// ./src/logic/tableUtils.js